import React from "react";

const CPP_User_Input = () => {
  return (
    <div>
      <h1>CPP_User_Input Component</h1>
      <p>Content for CPP_User_Input goes here...</p>
    </div>
  );
};

export default CPP_User_Input;
